import { render, staticRenderFns } from "./Memo.vue?vue&type=template&id=4d19447d&"
import script from "./Memo.vue?vue&type=script&lang=js&"
export * from "./Memo.vue?vue&type=script&lang=js&"
import style0 from "./Memo.vue?vue&type=style&index=0&id=4d19447d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports